// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Button} from '../lib/button';
import {Modal} from '../lib/modal';
import cn from 'classnames';
import styles from './agree_dialog.module.less';
import {Lottie} from '../lib/lottie';
import hola_opt from 'hola_opt';
// @ts-ignore
import {url2md5} from 'pub_config';
import {use_browser} from '../lib/use_browser';

const img_url = name=>url2md5(`/www/hola/pub/img/${name}`);

export interface i_agree_dlg_props {
    on_agree: ()=>void;
    on_animation_end?: ()=>void;
    on_close: ()=>void;
    width?: number;
    logo?: string;
    ver?: number;
    btn_text?: string|JSX.Element;
    btn_cls?: string;
    centered?: boolean;
    start_animation?: boolean;
    list_items?: (string|JSX.Element)[];
    after_cta_text?: string|JSX.Element;
}

export const Agree_body_short = (props:i_agree_dlg_props)=>{
    const {on_agree, btn_text, centered, btn_cls, on_animation_end,
        start_animation, list_items, after_cta_text} = props;
    const [a_step, set_a_step] = useState(0);
    const [inst, set_inst] = useState(null);
    const b = use_browser();
    useEffect(()=>{
        if (start_animation)
        {
            setTimeout(()=>{
                if (on_animation_end)
                {
                    set_a_step(1);
                    setTimeout(()=>{
                        inst.play();
                    }, 30);
                    setTimeout(()=>{
                        on_animation_end();
                    }, 5000);
                }
            }, 30);
        }
    }, [start_animation]);
    const default_after_cta_text = 'The installation file will be downloaded '
        +'next, click on it to install';
    return <div className={cn(styles.body, a_step>0 && styles.animation)}>
      <ul className={cn(styles.list, styles.list_3)}>
        {list_items ? <Fragment>
          {list_items.map((item, i)=><li key={i}>{item}</li>)}
        </Fragment> : hola_opt.www_hola.no_extension && b=='chrome' &&
          start_animation ?
          <li className="ic_1">
            <br/><br/><br/>
          </li> : <li className="ic_1">
          By installing Hola, you agree to our <a target="_blank"
          rel="noopener noreferrer" href="https://hola.org/legal">End User
          Agreement &amp; Privacy Statement</a> and understand that
          occasionally Hola will use the app to access websites to benefit
          other users and for business use by <a target="_blank"
            rel="noopener noreferrer"
            href="https://bright-sdk.com/eula">Bright Data</a>
        </li>}
      </ul>
      <div className={cn(styles.buttons, centered && styles.centered)}>
        <Lottie src={img_url('animation/download_button.json')}
          width={'320px'} height={'60px'} on_create={l=>set_inst(l)}
          cls={cn(styles.lottie_btn, a_step > 0 && styles.lottie_visible)}/>
        <Button cls={cn(styles.next_one, btn_cls, a_step>0 && styles.btn_hide)}
          on_click={()=>{
            if (on_animation_end)
            {
              set_a_step(1);
              setTimeout(()=>{
                inst.play();
              }, 30);
              setTimeout(()=>{
                on_animation_end();
              }, 5000);
            }
            on_agree();
          }} arrow caption={btn_text||'OK, I\'m in'}/>
      </div>
      <div className={styles.after_cta_text}>
        {after_cta_text||default_after_cta_text}
      </div>
    </div>;
};

export const Agree_dialog = (props:i_agree_dlg_props)=>{
    const {on_close, logo = 'logo.png', width = 537, ...body_props} = props;
    const LinkImg = Link as any;
    return <Modal is_open on_close={on_close} width={width} cls={styles.modal}>
      <Fragment>
        <div className={styles.header}>
          <LinkImg to="/">
            <img src={url2md5(`/www/hola/pub/img/${logo}`)} alt="agree"
              className="lazyload"/>
          </LinkImg>
        </div>
        <Agree_body_short on_close={on_close} centered {...body_props}/>
      </Fragment>
    </Modal>;
};
